export const WYSPR_WEBAPI_HOST =
    process.env.REACT_APP_WYSPR_WEBAPI_HOST || 'https://webapi.qa.wyspr.co.uk';

export interface Response<Type> {
    data: Type;
}

export interface PaginatedResponse<Type> {
    data: PaginatedData<Type>;
}

export interface PaginatedData<Type> {
    results: Type[];
    count: number;
}

export interface Pagination {
    page: number;
    limit: number;
}